import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  userSelectCustomerPortfolioValueChart:
    "userSelectCustomerPortfolioValueChart [Action]",
  userSelectCustomerPortfolioValueChartLoading:
    "userSelectCustomerPortfolioValueChartLoading [Action]",
  userSelectCustomerPortfolioValueChartAsync:
    "userSelectCustomerPortfolioValueChartAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const user_select_customer_portfolio_value_chart_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.userSelectCustomerPortfolioValueChart:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.userSelectCustomerPortfolioValueChartLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.userSelectCustomerPortfolioValueChartLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "user_select_marketer_customers_portfolio_value_chart",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.userSelectCustomerPortfolioValueChart,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.userSelectCustomerPortfolioValueChartLoading,
      payload: false,
    });
  }
}

export function* userSelectCustomerPortfolioValueChart() {
  yield takeLatest(
    actionTypes.userSelectCustomerPortfolioValueChartAsync,
    handleWorker
  );
}
